import { array, bool, shape, string } from 'prop-types'

export const customerDataType = shape({
  firstName: string,
  lastName: string,
  customerNumber: string,
  isEavCustomer: bool,
  isNewsletterMember: bool,
  isRedpointsMember: bool,
  mailingSubscriptions: array,
  phone: string,
  salutation: string,
})
